import { shallowEqual } from 'react-redux';
import {
  connectMediaStore,
  useMMSelector,
  useMMDispatchActions,
} from './withOwnReduxStore';
import { getAllowUploads, getAllowMultipleUploads } from '../selectors';
import { UploadFilePayload, FileUploadInfo } from '../../redux/uploads/types';
import { uploadFile, uploadFiles } from '../actions';
import { getAllUploads } from '../../redux/uploads/selectors';

export type WithFileUploadProps = {
  allowUploads: boolean;
  allowMultipleUploads?: boolean;
  fileUploads: FileUploadInfo[];
  uploadFile: (payload: Partial<UploadFilePayload>) => void;
  uploadFiles: (payload: Partial<UploadFilePayload>[]) => void;
};

const mapStateToProps = state => ({
  fileUploads: getAllUploads(state),
  allowUploads: getAllowUploads(state),
  allowMultipleUploads: getAllowMultipleUploads(state),
});

export const useFileUpload = (): WithFileUploadProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
  ...useMMDispatchActions({ uploadFile, uploadFiles }),
});

export default connectMediaStore(mapStateToProps, { uploadFile, uploadFiles });
